import { render, staticRenderFns } from "./fullPackageSetting.vue?vue&type=template&id=6dfd17e1&scoped=true"
import script from "./fullPackageSetting.vue?vue&type=script&lang=js"
export * from "./fullPackageSetting.vue?vue&type=script&lang=js"
import style0 from "./fullPackageSetting.vue?vue&type=style&index=0&id=6dfd17e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd17e1",
  null
  
)

export default component.exports